import { render, staticRenderFns } from "./QuotaLibrarySet.vue?vue&type=template&id=2fb41c3b&scoped=true&"
import script from "./QuotaLibrarySet.vue?vue&type=script&lang=ts&"
export * from "./QuotaLibrarySet.vue?vue&type=script&lang=ts&"
import style0 from "./QuotaLibrarySet.vue?vue&type=style&index=0&id=2fb41c3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb41c3b",
  null
  
)

export default component.exports